import React, { useEffect, useState } from 'react';
import SVG from './SVG.jsx';
import trackEvent from '../utils/trackEvent';
import AddToCartButton from './FitFinder/AddToCart.jsx';
import Step1 from './FitFinder/Step1.jsx';
import Step2 from './FitFinder/Step2.jsx';
import Step3 from './FitFinder/Step3.jsx';
import Step4 from './FitFinder/Step4.jsx';
import ResultAnimation from './FitFinder/ResultAnimation.jsx';
import Result from './FitFinder/Result.jsx';

export default function FitFinderForm(props) {
  const isSneaker = true;
  const screenCount = (isSneaker ? 3 : 4);
  const standards = [{ label: `Men's`, code: 'mens' }, { label: `Women's`, code: 'womens' }];
  const geoCountryCode = window.Theme && window.Theme.localizationCountry;
  const locations = [{ label: 'US', regions: ['US', 'CA'], code: 'us' }, { label: 'UK', regions: ['GB', 'IE', 'ZA'], code: 'uk' }, { label: 'EU', regions: ['EU'], code: 'eu' }];
  const strings = window.themeStrings || {};

  const sizes = {
    mens: [
      {
        us: 5.5,
        uk: 5,
        eu: 38,
        store: 6,
        presented: false,
      },
      {
        us: 5.5,
        uk: 5,
        eu: 38,
        store: 6,
        presented: false,
      },
      {
        us: 6,
        uk: 5.5,
        eu: 39,
        store: 6,
        presented: true,
      },
      {
        us: 6.5,
        uk: 6,
        eu: 39,
        store: 6.5,
        presented: true,
      },
      {
        us: 7,
        uk: 6.5,
        eu: 40,
        store: 7,
        presented: true,
      },
      {
        us: 7.5,
        uk: 7,
        eu: 40,
        store: 7.5,
        presented: true,
      },
      {
        us: 8,
        uk: 7.5,
        eu: 41,
        store: 8,
        presented: true,
      },
      {
        us: 8.5,
        uk: 8,
        eu: 41,
        store: 8.5,
        presented: true,
      },
      {
        us: 9,
        uk: 8.5,
        eu: 42,
        store: 9,
        presented: true,
      },
      {
        us: 9.5,
        uk: 9,
        eu: 42,
        store: 9.5,
        presented: true,
      },
      {
        us: 10,
        uk: 9.5,
        eu: 43,
        store: 10,
        presented: true,
      },
      {
        us: 10.5,
        uk: 10,
        eu: 43,
        store: 10.5,
        presented: true,
      },
      {
        us: 11,
        uk: 10.5,
        eu: 44,
        store: 11,
        presented: true,
      },
      {
        us: 11.5,
        uk: 11,
        eu: 44,
        store: 11.5,
        presented: true,
      },
      {
        us: 12,
        uk: 11.5,
        eu: 45,
        store: 12,
        presented: true,
      },
      {
        us: 12.5,
        uk: 12,
        eu: 45,
        store: 12.5,
        presented: true,
      },
      {
        us: 13,
        uk: 12.5,
        eu: 46,
        store: 13,
        presented: true,
      },
      {
        us: 13.5,
        uk: 13,
        eu: 46,
        store: 13.5,
        presented: true,
      },
      {
        us: 14,
        uk: 13.5,
        eu: 47,
        store: 14,
        presented: true,
      },
      {
        us: 14.5,
        uk: 14,
        eu: 47,
        store: 14.5,
        presented: true,
      },
      {
        us: 15,
        uk: 14.5,
        eu: 48,
        store: 15,
        presented: true,
      },
      {
        us: 15.5,
        uk: 15,
        eu: 48,
        store: 15.5,
        presented: true,
      },
      {
        us: 16,
        uk: 15.5,
        eu: 49,
        store: 16,
        presented: true,
      },
      {
        us: 16.5,
        uk: 16,
        eu: 49,
        store: 16,
        presented: false,
      },
      {
        us: 17,
        uk: 16.5,
        eu: 50,
        store: 16,
        presented: false,
      },
    ],
    womens: [
      {
        us: 3.5,
        uk: 1.5,
        eu: 34,
        store: 4,
        presented: false,
      },
      {
        us: 3.5,
        uk: 1.5,
        eu: 34,
        store: 4,
        presented: false,
      },
      {
        us: 4,
        uk: 2,
        eu: 35,
        store: 4,
        presented: true,
      },
      {
        us: 4.5,
        uk: 2.5,
        eu: 35,
        store: 4.5,
        presented: true,
      },
      {
        us: 5,
        uk: 3,
        eu: 36,
        store: 5,
        presented: true,
      },
      {
        us: 5.5,
        uk: 3.5,
        eu: 36,
        store: 5.5,
        presented: true,
      },
      {
        us: 6,
        uk: 4,
        eu: 37,
        store: 6,
        presented: true,
      },
      {
        us: 6.5,
        uk: 4.5,
        eu: 37,
        store: 6.5,
        presented: true,
      },
      {
        us: 7,
        uk: 5,
        eu: 38,
        store: 7,
        presented: true,
      },
      {
        us: 7.5,
        uk: 5.5,
        eu: 38,
        store: 7.5,
        presented: true,
      },
      {
        us: 8,
        uk: 6,
        eu: 39,
        store: 8,
        presented: true
      },
      {
        us: 8.5,
        uk: 6.5,
        eu: 39,
        store: 8.5,
        presented: true
      },
      {
        us: 9,
        uk: 7,
        eu: 40,
        store: 9,
        presented: true
      },
      {
        us: 9.5,
        uk: 7.5,
        eu: 40,
        store: 9.5,
        presented: true
      },
      {
        us: 10,
        uk: 8,
        eu: 41,
        store: 10,
        presented: true
      },
      {
        us: 10.5,
        uk: 8.5,
        eu: 41,
        store: 10.5,
        presented: true
      },
      {
        us: 11,
        uk: 9,
        eu: 42,
        store: 11,
        presented: true
      },
      {
        us: 11.5,
        uk: 9.5,
        eu: 42,
        store: 11.5,
        presented: true
      },
      {
        us: 12,
        uk: 10,
        eu: 43,
        store: 12,
        presented: true
      },
      {
        us: 12.5,
        uk: 10.5,
        eu: 43,
        store: 12.5,
        presented: true
      },
      {
        us: 13,
        uk: 11,
        eu: 44,
        store: 13,
        presented: true
      },
      {
        us: 13.5,
        uk: 11.5,
        eu: 44,
        store: 13,
        presented: false
      },
      {
        us: 14,
        uk: 12,
        eu: 45,
        store: 13,
        presented: false
      },
    ]
  }

  const widths = {
    mens: ['B', 'C', 'D', 'E', 'EE', 'EEE'],
    womens: ['Narrow', 'Wide'],
  }

  if (geoCountryCode) {
    if (geoCountryCode !== 'US') {
      locations[0].label = 'US/CA';
    }
    let exactMatch = 'eu';
    for (const location of locations) {
      if (location.regions.includes(geoCountryCode)) {
        exactMatch = location.code;
        break;
      }
    }
    locations.sort(a => {
      if (exactMatch === a.code) {
        return -1;
      }
      return 1;
    })
  }

  const isWomens = props.product.vendor.includes('Women');
  const widthOption = props.product.options_with_values.find(o => o.name === 'Width');
  const hasWideWidth = Boolean(widthOption && widthOption.values.find(v => v.includes('Wide')));

  if (isWomens) {
    standards.reverse();
  }

  let hasBootSize = null;
  if (isSneaker) {
    hasBootSize = false;
  };

  const [step, setStep] = useState(1);
  const [getLocation, setLocation] = useState(locations[0]);
  const [getStandard, setStandard] = useState(standards[0]);
  const [getSneakerSize, setSneakerSize] = useState({});
  const [getSneakerSize2, setSneakerSize2] = useState({});
  const [getConfirmSneakerSize2, setConfirmSneakerSize2] = useState("");
  const [getHasBootSize, setHasBootSize] = useState(hasBootSize);
  const [getBootSize, setBootSize] = useState({});
  const [getBootSize2, setBootSize2] = useState({});
  const [getHasWidth, setHasWidth] = useState(null);
  const [getWidth, setWidth] = useState(null);
  const [recommendedSize, setRecommendedSize] = useState(null);
  const [recommendedWidth, setRecommendedWidth] = useState(null);
  const [recommendedVariant, setRecommendedVariant] = useState({});
  const [validForm, setValidForm] = useState(false);

  useEffect(() => {
    setSneakerSize2({});
  }, [getSneakerSize.us]);

  useEffect(() => {
    setConfirmSneakerSize2("");
  }, [getSneakerSize2.us]);

  useEffect(() => {
    setWidth(null);
  }, [getHasWidth]);

  useEffect(() => {
    setBootSize({});
  }, [getHasBootSize]);

  useEffect(() => {
    setBootSize2({});
  }, [getBootSize.us]);

  useEffect(() => {
    if (step > 1 && step < 5) {
      advanceForm();
    }
  }, [getSneakerSize2.us, getHasBootSize, getBootSize2, getHasWidth, getWidth, getConfirmSneakerSize2]);

  useEffect(() => {
    if (validateForm()) {
      setValidForm(true);
    } else {
      setValidForm(false);
    }
  })

  const validateForm = () => {
    if (step === 1) {
      return Boolean(getLocation.code && getStandard.code)
    }
    if (step === 2) {
      if (getSneakerSize2.us > getSneakerSize.us && !getConfirmSneakerSize2) {
        return false;
      }
      return Boolean(getSneakerSize.us && getSneakerSize2.us)
    }
    if (step === 3) {
      return Boolean(getHasBootSize === false || getHasBootSize && getBootSize.us && getBootSize2.us)
    }
    if (step === 4) {
      return Boolean(getHasWidth === false || getHasWidth && getWidth)
    }
    if (step === 5) {
      return true;
    }
  }

  const advanceForm = () => {
    if (validateForm()) {
      if (step === 1) {
        setStep(2);
        trackEvent('Completed Question 1', { handle: props.product.handle, vendor: props.product.vendor, sizeStandard: `${getStandard.label} ${getLocation.code.toUpperCase()}` });
      } else if (step === 2) {
        trackEvent('Completed Question 2', { handle: props.product.handle, vendor: props.product.vendor, primarySize: getSneakerSize.us, secondarySize: getSneakerSize2.us, secondarySizeQualifier: getConfirmSneakerSize2 });
        if (isSneaker) {
          return setStep(4);
        } else {
          return setStep(3);
        }
      } else if (step === 3) {
        trackEvent('Completed Question 3', { handle: props.product.handle, vendor: props.product.vendor, primarySize: getBootSize.us, secondarySize: getBootSize2.us, gywTrue: getHasBootSize });
        return setStep(4);
      } else if (step === 4) {
        trackEvent('Completed Question 4', { handle: props.product.handle, vendor: props.product.vendor, widthTrue: getHasWidth, width: getWidth });
        if (window.customExperiences && window.customExperiences.showFFAnimation) {
          return setStep(5);
        }
        computeResult();
        return setStep(6);
      } else if (step === 5) {
        computeResult();
        return setStep(6);
      }
    }
  }

  const goBack = () => {
    if (step === 4) {
      if (isSneaker) {
        return setStep(2);
      } else {
        return setStep(3);
      }
    }
    if (step === 3) {
      return setStep(2);
    }
    if (step === 2) {
      return setStep(1);
    }
  }

  const resetForm = () => {
    setStep(1);
    setSneakerSize({});
    setSneakerSize2({});
    setHasBootSize(hasBootSize);
    setBootSize({});
    setBootSize2({});
    setHasWidth(null);
    setWidth(null);
    setRecommendedSize(null);
    setRecommendedWidth(null);
  }

  const computeResult = () => {
    const fullDown = props.product.tags.includes('fqv2:full-down');
    const halfDown = props.product.tags.includes('fqv2:half-down');
    const ttsSmaller = props.product.tags.includes('fqv2:tts-down');
    const ttsLarger = props.product.tags.includes('fqv2:tts-up');
    const halfUp = props.product.tags.includes('fqv2:half-up');
    const fullUp = props.product.tags.includes('fqv2:full-up');
    let result = 0;
    if (getHasBootSize === false) {
      if ((getConfirmSneakerSize2 === "Frequently" || (getConfirmSneakerSize2 === "Occasionally" && props.product.tags.includes("fit-quiz:occasional-true"))) && getSneakerSize2.us && getSneakerSize2.us !== getSneakerSize.us) {
        result = getSneakerSize2.us;
        const smaller = Math.min(getSneakerSize.us, getSneakerSize2.us);
        const larger = Math.max(getSneakerSize.us, getSneakerSize2.us);
        if (fullDown) {
          result = smaller - 0.5;
        } else if (halfDown || ttsSmaller) {
          result = smaller;
        } else if (halfUp || ttsLarger) {
          result = larger;
        } else if (fullUp) {
          result = larger + 0.5;
        }
      } else {
        result = getSneakerSize.us;
        let smaller = getSneakerSize.us;
        if (getSneakerSize2.us && getSneakerSize2.us !== getSneakerSize.us) {
          smaller = Math.min(getSneakerSize.us, getSneakerSize2.us);
        }
        if (fullDown) {
          result = getSneakerSize.us - 1;
        } else if (halfDown) {
          result = getSneakerSize.us - 0.5;
        } else if (ttsSmaller) {
          result = smaller;
        } else if (ttsLarger) {
          result = getSneakerSize.us;
        } else if (halfUp) {
          result = getSneakerSize.us + 0.5;
        } else if (fullUp) {
          result = getSneakerSize.us + 1;
        }
      }
    } else {
      if (getBootSize2.us && getBootSize2.us !== getBootSize.us) {
        result = getBootSize2.us;
        const smaller = Math.min(getBootSize.us, getBootSize2.us);
        const larger = Math.max(getBootSize.us, getBootSize2.us);
        if (fullDown) {
          result = smaller - 0.5;
        } else if (halfDown || ttsSmaller) {
          result = smaller;
        } else if (halfUp || ttsLarger) {
          result = larger;
        } else if (fullUp) {
          result = larger + 0.5;
        }
      } else {
        result = getBootSize.us;
        if (fullDown) {
          result = getBootSize.us - 0.5;
        } else if (halfDown || ttsSmaller || ttsLarger || halfUp) {
          result = getBootSize.us;
        } else if (fullUp) {
          result = getBootSize.us + 0.5;
        }
      }
    }

    let width = 'Standard';

    if (getHasWidth === true) {
      if (getWidth === 'Wide' || getWidth === 'EE' || getWidth === 'EEE') {
        if (hasWideWidth) {
          if (widthOption.values.find(v => v.includes('Wide (EE)')) && getWidth === 'EE') {
            width = 'Wide (EE)';
          } else if (widthOption.values.find(v => v.includes('Wide (EEE)')) && (getWidth === 'EEE' || getWidth === 'EE')) {
            width = 'Wide (EEE)';
          } else if (widthOption.values.find(v => v.includes('Wide (EE)')) && getWidth === 'EEE') {
            width = 'Wide (EE)';
            result += 0.5;
          } else {
            width = 'Wide';
          }
        } else {
          result += 0.5;
        }
      } else if (getWidth === 'Narrow' || getWidth === 'B' || getWidth === 'C') {
        result -= 0.5;
      }
    }

    if (isWomens && getStandard.code === 'mens') {
      result += 1.5;
    } else if (!isWomens && getStandard.code === 'womens') {
      result -= 1.5;
    }

    if (result) {
      setRecommendedSize(result);
      setRecommendedWidth(width);
    }
  }

  const Counter = () => {
    if (step > 4) {
      return (<p className="counter">Result</p>);
    }
    if (isSneaker && step === 4) {
      return (<p className="counter">Step 3 <span className="counter-subtext">of {screenCount}</span></p>)
    }
    return (<p className="counter">Step {step} <span className="counter-subtext">of {screenCount}</span></p>)
  }

  const Footer = () => {
    if (step === 5) {
      return (null)
    } else if (step > 4) {
      return (
        <div className="form-footer form-footer-column">
          <AddToCartButton recommendedVariant={recommendedVariant} recommendedSize={recommendedSize} product={props.product} _optionChanged={props._optionChanged} closeFitFinder={props.closeFitFinder} />
          <button className="form-footer-button action-button back-button start-over-button" type="button" onClick={() => resetForm()}>
            <SVG icon="arrow-thin-left" />
            Start Over
          </button>
        </div>
      )
    } else if (step === 1) {
      return (
        <div className="form-footer">
          <button disabled={!validForm} className={validForm ? "form-footer-button action-button" : "form-footer-button action-button button-disabled"} type="button" onClick={() => advanceForm()}>
            {strings.next_question}
            <SVG icon="arrow-thin-right" />
          </button>
        </div>
      )
    }
    return (
      <div className="form-footer">
        <button className="form-footer-button action-button back-button" type="button" onClick={() => goBack()}>
          <SVG icon="arrow-thin-left" />
          Back
        </button>
        <button disabled={!validForm} className={validForm ? "form-footer-button action-button" : "form-footer-button action-button button-disabled"} type="button" onClick={() => advanceForm()}>
          {strings.next_question}
          <SVG icon="arrow-thin-right" />
        </button>
      </div>
    );
  }

  return (
    <div id="fit-finder" className="ff-wrap">
      <div className="ff-header">
        <img src="https://cdn.shopify.com/s/files/1/0419/1525/files/ruler-icon.svg?10153809238683260143" className="sizing-ruler" />
        <h1 className="title">
          {strings.fit_finder_heading}
        </h1>
        <div className="form-counter">
          <Counter />
        </div>
        <progress className="ff-progress" value={step - 1} max={screenCount - 1}></progress>
      </div>

      <div className={step === 6 ? "ff-form ff-result" : "ff-form"}>
        {step === 1 && <Step1 locations={locations} setLocation={setLocation} getLocation={getLocation} standards={standards} setStandard={setStandard} getStandard={getStandard} step={step} setStep={setStep} _openSizeGuide={props._openSizeGuide} closeFitFinder={props.closeFitFinder} />}
        {step === 2 && <Step2 sizes={sizes} getLocation={getLocation} getStandard={getStandard} getSneakerSize={getSneakerSize} setSneakerSize={setSneakerSize} getSneakerSize2={getSneakerSize2} setSneakerSize2={setSneakerSize2} getConfirmSneakerSize2={getConfirmSneakerSize2} setConfirmSneakerSize2={setConfirmSneakerSize2} step={step} setStep={setStep} isWomens={isWomens} isSneaker={isSneaker} />}
        {step === 3 && <Step3 sizes={sizes} getLocation={getLocation} getStandard={getStandard} getHasBootSize={getHasBootSize} setHasBootSize={setHasBootSize} getBootSize={getBootSize} setBootSize={setBootSize} getBootSize2={getBootSize2} setBootSize2={setBootSize2} step={step} setStep={setStep} product={props.product} isWomens={isWomens} isSneaker={isSneaker} />}
        {step === 4 && <Step4 widths={widths} getLocation={getLocation} getStandard={getStandard} getHasWidth={getHasWidth} setHasWidth={setHasWidth} getWidth={getWidth} setWidth={setWidth} step={step} setStep={setStep} />}
        {step === 5 && <ResultAnimation advanceForm={advanceForm} />}
        {step === 6 && <Result product={props.product} recommendedSize={recommendedSize} recommendedWidth={recommendedWidth} hasWideWidth={hasWideWidth} widthOption={widthOption} recommendedVariant={recommendedVariant} setRecommendedVariant={setRecommendedVariant} />}
      </div>
      <Footer />
    </div>
  )
}